import { render } from "./CallDetails.vue?vue&type=template&id=acdbcf72&ts=true"
import script from "./CallDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallDetails.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acdbcf72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acdbcf72', __exports__)) {
    api.reload('acdbcf72', __exports__)
  }
  
  module.hot.accept("./CallDetails.vue?vue&type=template&id=acdbcf72&ts=true", () => {
    api.rerender('acdbcf72', render)
  })

}


export default __exports__